module.exports = __webpack_public_path__ + "img/bac.5c0bb12d.png";